import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'button[app-select-button]',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'flex w-full items-center justify-between gap-2.5 h-10.5 pl-3.5 pr-3 bg-[var(--bg2)] border border-line2 ' +
      'rounded-[var(--r)] text-sm leading-none text-ink cursor-pointer ' +
      'transition-[border-color] duration-[var(--t-fast)] ease-[var(--ease-smooth)] hover:border-acc-line',
    type: 'button',
  },
  template: `
    <span class="truncate"><ng-content /></span>
    <span class="shrink-0 text-c3">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="size-4.5"
      >
        <path d="m6 9 6 6 6-6" />
      </svg>
    </span>
  `,
})
export class SelectButtonComponent {}
